var _g;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBetsFavOnSmaller = function SvgBetsFavOnSmaller(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 30.305,
    viewBox: "0 0 59 30.305",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12031",
    "data-name": "Group 12031",
    transform: "translate(-8 -345)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_783",
    "data-name": "Rectangle 783",
    width: 59,
    height: 30.305,
    rx: 15.152,
    transform: "translate(8 345)",
    fill: "#ffc400"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon_bet_favorite",
    "data-name": "icon bet favorite",
    transform: "translate(30.816 348.877)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1113",
    "data-name": "Path 1113",
    d: "M0,0H10.981V17.905L5.634,13.926,0,17.905Z",
    transform: "translate(0 3.308)",
    fill: "#ffc400",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1117",
    "data-name": "Path 1117",
    d: "M0,0H10.981V17.905L5.634,13.926,0,17.905Z",
    transform: "translate(0 3.308)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_997",
    "data-name": "Group 997",
    transform: "translate(4.746 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_995",
    "data-name": "Group 995",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_156",
    "data-name": "Ellipse 156",
    fill: "#ffc400",
    stroke: "#ffc400",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.609,
    cy: 7.609,
    r: 7.609,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.609,
    cy: 7.609,
    r: 7.109,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_996",
    "data-name": "Group 996",
    transform: "translate(2.117 1.624)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M10.141,15.035l-2.677-.192a.143.143,0,0,1-.125-.092l-1.02-2.482a.9.9,0,0,0-1.659,0L3.638,14.756a.15.15,0,0,1-.125.092L.84,15.04a.884.884,0,0,0-.789.606.877.877,0,0,0,.266.968l2.069,1.709a.148.148,0,0,1,.049.148L1.8,21.051a.872.872,0,0,0,.141.763.892.892,0,0,0,.7.351.85.85,0,0,0,.472-.143l2.261-1.407a.147.147,0,0,1,.154,0l2.283,1.4a.855.855,0,0,0,.476.148.877.877,0,0,0,.678-.331.906.906,0,0,0,.172-.774l-.633-2.588a.151.151,0,0,1,.049-.15l2.1-1.713a.9.9,0,0,0-.521-1.574Zm.172,1.152L8.218,17.9a.7.7,0,0,0-.235.7l.633,2.583a.353.353,0,0,1-.067.306.329.329,0,0,1-.25.127.312.312,0,0,1-.179-.06L5.827,20.15a.7.7,0,0,0-.365-.1.686.686,0,0,0-.367.105l-2.27,1.411a.332.332,0,0,1-.443-.081.317.317,0,0,1-.047-.293l.633-2.59a.7.7,0,0,0-.233-.7L.672,16.194a.347.347,0,0,1,.206-.608l2.677-.192a.693.693,0,0,0,.593-.429L5.17,12.479a.348.348,0,0,1,.644,0l1.022,2.485a.693.693,0,0,0,.593.429l2.681.195a.337.337,0,0,1,.3.235A.345.345,0,0,1,10.313,16.187Z",
    transform: "translate(0 -11.714)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.7
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBetsFavOnSmaller, _extends({
    svgRef: ref
  }, props));
});
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };